import useCurrencyCode from "@casino/legacy/client/hooks/currency/useCurrencyCode";
import useHover from "@casino/legacy/client/hooks/events/useHover";
import useAgentData from "@casino/legacy/client/hooks/useAgentData";
import type { GameFragment } from "@workspace/casino_core/fragments/GameFragment";
import type { SingleGameFragment } from "@workspace/casino_core/fragments/SingleGameFragment";
import { useCallback, useState } from "react";
import hasAnyData from "./helpers/hasAnyData";

const MOUSE_OUT_TIMEOUT = 500;

// List cards carry only the shared fields; the play page the full game.
type GameDetailsGame = GameFragment & Partial<SingleGameFragment>;

const useGameDetails = (game: GameDetailsGame) => {
  const { isHovered, hoverRef } = useHover<HTMLDivElement>(MOUSE_OUT_TIMEOUT);
  const { isTablet } = useAgentData();
  const [visible, setVisible] = useState(false);
  const handleClick = useCallback(() => {
    if (isTablet) {
      setVisible(true);
    }
  }, [isTablet]);

  const handleClose = useCallback(() => {
    setVisible(false);
  }, []);

  const currencyCode = useCurrencyCode();
  const hasData = hasAnyData(game, currencyCode);
  return {
    hasData,
    isHovered,
    hoverRef,
    visible,
    handleClick,
    handleClose,
  };
};

export default useGameDetails;
